<template>
  <cbm-card
    title="Faturamento"
    is-currency
    :number-text="value"
    :percent-text="percentageText"
    :percent-description="percentageDescription"
    :tooltip="tooltip"
    :percentage-tooltip="percentageTooltip"
    simple-card
    :boolean-loader="loading"
  />
</template>

<script>
import CbmCard from '@/components/CbmCard.vue'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ResultsRevenueCard',
  components: {
    CbmCard,
  },
  props: {
    metrics: Object,
    loading: {
      type: Boolean,
      default: false,
    },
    isMercapromo: {
      type: Boolean,
      default: false,
    },
    offerType: {
      type: String,
      default: '',
    },
  },
  computed: {
    value() {
      return localeString(this.metrics?.clients_metrics?.with_sales?.revenue || 0, 2)
    },
    percentageText() {
      let percent = 0
      if (this.metrics?.clients_metrics?.total?.revenue) {
        percent = (this.metrics?.clients_metrics?.with_sales?.revenue / this.metrics?.clients_metrics?.total?.revenue) * 100
        percent = percent.toFixed(2)
      }
      return `${percent}%`
    },
    tooltip() {
      return 'Faturamento dos cupons com produtos em oferta'
    },
    percentageDescription() {
      return 'do faturamento total'
    },
    percentageTooltip() {
      return `Faturamento total no período ofertado: R$${
        this.metrics?.clients_metrics?.total?.revenue ? localeString(this.metrics?.clients_metrics?.total?.revenue, 2) : 0
      }`
    },
  },
}
</script>
